import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./assets/stylesheets/index.css";
import { BrowserRouter } from "react-router-dom";
import { Analytics } from "./components/analytics";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      // This key needs to exactly match the configuration in vite.config.js
      filterKeys: ["edubox-war-and-peace"],
      behaviour: "drop-error-if-exclusively-contains-third-party-frames",
    }),
  ],
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Analytics />
    <App />
  </BrowserRouter>,
);
